import { Pipe, PipeTransform } from '@angular/core';
import { CommentThread } from '../../gallery-shared/components/comments/comments.component';

@Pipe({
  name: 'resolvedComments',
  standalone: true,
})
export class ResolvedCommentsPipe implements PipeTransform {
  transform(comments: CommentThread[], showResolved: boolean): CommentThread[] {
    if (showResolved) return comments;
    return comments.filter(comment => {
      if (comment.resolvedTempOverride !== undefined) {
        return !comment.resolvedTempOverride;
      }

      return !comment.resolved;
    });
  }
}
